import { render, staticRenderFns } from "./ReportSubCategory.vue?vue&type=template&id=60816d8c"
import script from "./ReportSubCategory.vue?vue&type=script&lang=js"
export * from "./ReportSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports